export class AssetPairRecordShort {
  constructor (record) {
    this._record = record
    this.base = record.base
    this.quote = record.quote
    this.priceBuy = record.price
    this.priceSell = 1 / record.price
  }
}



// WEBPACK FOOTER //
// ./src/js/records/asset_pair.record.short.js